import { ChartAxisComponent }     from './axis/chart-axis.component';
import { CsBarChartComponent }    from './bar/bar-chart.component';
import { CsPieChartComponent }    from './pie/pie-chart.component';
import { CsChartLegendComponent } from './legend/chart-legend.component';

import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule }         from '@angular/common';
import { CsChartComponent }     from './chart.component';
import { CsLineChartComponent }      from './line/line-chart.component';
import { CsWaterfallChartComponent } from './waterfall/waterfall-chart.component';
import { CsTreemapChartComponent }   from './treemap/treemap-chart.component';
import { CsFunnelChartComponent }    from './funnel/funnel-chart.component';
import { CsScatterChartComponent }   from './scatter/scatter-chart.component';
import { CsGaugeChartComponent }     from './gauge/gauge-chart.component';
import { CsDecompositionChartComponent } from './decomposition/decomposition-chart.component';
import { NgbPopoverModule }     from '@cs/components/ngb-popover';


@NgModule({
	declarations:    [
		CsChartComponent,
		CsChartLegendComponent,
		CsBarChartComponent,
		CsPieChartComponent,
		CsLineChartComponent,
		CsWaterfallChartComponent,
		CsTreemapChartComponent,
		CsFunnelChartComponent,
		CsScatterChartComponent,
		CsGaugeChartComponent,
		CsDecompositionChartComponent,
		ChartAxisComponent],
	exports:         [CsChartComponent, CsChartLegendComponent],
	imports:         [CommonModule, NgbPopoverModule]
})
export class CsChartModule {
	static forRoot(): ModuleWithProviders<CsChartModule> {
		return {ngModule: CsChartModule};
	}
}
